import React from "react";

/* eslint-disable max-len */
export default function CaptionIcon() {
    return (
        <svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 58 16" enableBackground="new 0 0 58 16" xmlSpace="preserve">
		<g>
			<path fill="#ADADAD" d="M55,16H3c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3h52c1.7,0,3,1.3,3,3v10C58,14.7,56.7,16,55,16z"/>
			<g>
				<path fill="#FFFFFF" d="M5.5,8.1c0-2.7,1.7-4.3,3.8-4.3c1,0,1.9,0.5,2.4,1l-0.9,1c-0.4-0.4-0.9-0.7-1.5-0.7C8.1,5.2,7.2,6.3,7.2,8
					c0,1.8,0.8,2.8,2.1,2.8c0.7,0,1.2-0.3,1.7-0.8l0.9,1c-0.7,0.8-1.5,1.2-2.6,1.2C7.2,12.3,5.5,10.8,5.5,8.1z"/>
				<path fill="#FFFFFF" d="M16.9,10h-2.6l-0.6,2.1h-1.7L14.7,4h1.9l2.6,8.1h-1.7L16.9,10z M16.6,8.8l-0.2-0.9
					c-0.3-0.8-0.5-1.8-0.7-2.7h0c-0.2,0.9-0.5,1.8-0.7,2.7l-0.2,0.9H16.6z"/>
				<path fill="#FFFFFF" d="M20.2,4h2.7C24.7,4,26,4.6,26,6.5c0,1.9-1.4,2.7-3.1,2.7h-1.1v2.9h-1.6V4z M22.8,7.9
					c1.1,0,1.7-0.5,1.7-1.4c0-0.9-0.6-1.3-1.7-1.3h-0.9v2.7H22.8z"/>
				<path fill="#FFFFFF" d="M28.9,5.3h-2.3V4h6.2v1.4h-2.3v6.8h-1.6V5.3z"/>
				<path fill="#FFFFFF" d="M34.2,4h1.6v8.1h-1.6V4z"/>
				<path fill="#FFFFFF" d="M37.4,8c0-2.7,1.5-4.2,3.6-4.2c2.2,0,3.6,1.6,3.6,4.2c0,2.6-1.5,4.3-3.6,4.3C38.9,12.3,37.4,10.6,37.4,8z
					M43,8c0-1.7-0.8-2.8-2-2.8c-1.2,0-2,1-2,2.8c0,1.7,0.8,2.8,2,2.8C42.3,10.9,43,9.7,43,8z"/>
				<path fill="#FFFFFF" d="M46.3,4h1.7l2.4,4.3l0.8,1.8h0.1C51.1,9.2,51,8.1,51,7.2V4h1.5v8.1h-1.7l-2.4-4.4L47.7,6h-0.1
					c0.1,0.9,0.2,1.9,0.2,2.8v3.3h-1.5V4z"/>
			</g>
		</g>
		</svg>
    );
}
